import { BlockInfoDTO, PriceCategory, SeatmapClient, Selection, Type } from "@eventim/seatmap-client";

export class SeatmapClientDataViewModel {

    private readonly _selectedTickets: Selection[] = [];

    constructor(private client: SeatmapClient) {
        this._selectedTickets = client.getCurrentSelection();
    }

    public get selectedTickets(): Selection[] {
        return this._selectedTickets;
    }

    public get ticketNumber(): number {
        return this._selectedTickets.length;
    }

    public getPriceCategoryFor(selection: Selection): PriceCategory | undefined {
        if (selection.selectable.priceCategory) {
            return this.client.getPriceCategoryById(this.client.getElementIdByType(selection.selectable.priceCategory.id, Type.PRICE_CATEGORY));
        }

        return undefined;
    }

    public async getBlockInfoFor(selection: Selection): Promise<BlockInfoDTO> {
        return await this.client.loadBlockInfo(this.client.getElementIdByType(selection.selectable.blockId, Type.BLOCK));
    }
}
